<template>
  <div class="el-section">
    <div class="emd-container _footer_end">
      <div class="emd-container__header eu-py_4_md eu-px_5_md">
        <h2 class="emd-text _size_section _color_default">{{ $t('title') }}</h2>
      </div>
      <hr class="emd-divider" />
      <div class="emd-container__content eu-pa_5_md  ">
        <emd-alert v-if="tabbarError.status" variant="danger" :title="$t('tabbarError')" @cancel="tabbarError.status = false" autoclose />
        <div class="eu-flex">
          <div class="eu-flex-item eu-basis_12 eu-basis_4_sm eu-basis_3_md">
            <div class="emd-form-group">
              <label class="emd-label _required" for="amount" >{{ $t('amount') }}</label>
              <money class="emd-input" type="tel" id="amount" name="amount" v-bind="money" v-model="item.price" :class="{'_state_error': $v.item.price.$invalid && showFeedbacks.status}" @input="filterPrice"></money>
              <p class="emd-input-feedback">{{ $t('hint.amount') }}</p>
              <p class="emd-input-feedback _state_error" v-if="$v.item.price.$invalid && showFeedbacks.status" >{{ $t('hint.value') }}</p>
            </div>
          </div>
          <div class="eu-flex-item eu-basis_12 eu-basis_8_sm eu-basis_5_md">
            <div class="emd-form-group">
              <label class="emd-label _required" for="description">{{ $t('description') }}</label>
              <input class="emd-input" type="text" id="description" name="description" :class="{'_state_error': $v.item.description.$invalid && showFeedbacks.status}" v-model="item.description" />
              <p class="emd-input-feedback _state_error" v-if="$v.item.description.$invalid && showFeedbacks.status" >{{ $t('hint.required') }}</p>
            </div>
          </div>

          <div class="eu-flex-divider eu-my_1_md"></div>

          <div class="eu-flex-item eu-basis_12 eu-basis_6_sm eu-basis_5_md">
            <div class="emd-form-group">
              <label class="emd-label _required" for="interval_count">{{ $t('interval_count') }}</label>
              <div class="eu-flex">
                <div class="eu-flex-item eu-basis_12 eu-basis_4_sm eu-mb_3_mobile">
                  <input class="emd-input eu-align_right_sm" type="text" name="interval_count" id="interval_count" placeholder="0" :class="{'_state_error': $v.subscription.interval_count.$invalid && showFeedbacks.status}" v-model="subscription.interval_count" @input="filterInterval" />
                  <p class="emd-input-feedback _state_error" v-if="$v.subscription.interval_count.$invalid && showFeedbacks.status" >{{ $t('hint.value') }}</p>
                </div>
                <div class="eu-flex-item eu-basis_12 eu-basis_8_sm">
                  <div class="emd-select">
                    <select v-model="subscription.interval" :class="{'_state_error': $v.subscription.interval.$invalid && showFeedbacks.status}">
                      <option v-for="(item, index) in interval" :key="index" :value="item">{{ $t(`interval.${item}`) }}</option>
                    </select>
                    <div class="emd-select__arrow"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="eu-flex-item eu-basis_12 eu-basis_6_sm eu-basis_5_md">
            <div class="emd-form-group">
              <label class="emd-label _required" for="start_at">{{ $t('start_at') }}</label>
              <div class="eu-flex">
                <div class="eu-flex-item eu-basis_6 eu-basis_6_sm">
                  <input class="emd-input" type="text" name="start_at" id="start_at" placeholder="dd/mm/aaaa" v-mask="'##/##/####'" :class="{'_state_error': showFeedbacks.status && validateStartAt}" v-model="subscription.start_at" />
                </div>
                <div class="eu-flex-item eu-basis_6 eu-basis_6_sm">
                  <label class="emd-radio-button eu-flex eu-px_3 eu-py_2">
                    <input class="emd-radio-button__input" type="radio" name="start_at_radio" id="start_at_radio" :value="today" v-model="subscription.start_at" />
                    <div class="emd-radio-button__area"></div>
                    <span class="emd-radio-button__text">{{ $t('today', { today: today }) }}</span>
                  </label>
                </div>
              </div>
            </div>
            <p class="emd-input-feedback _state_error" v-if="showFeedbacks.status && validateStartAt" >{{ $t('hint.date', { date: today }) }}</p>
          </div>

          <div class="eu-flex-divider eu-my_1_md"></div>

          <!-- item selecionado / não selecionado -->
          <div class="eu-flex-item eu-basis_12">
            <div class="el-chunk">
              <p class="emd-text _type_caption">{{ $t('cycle.title') }}</p>
            </div>
            <div class="eu-flex">

              <div class="eu-flex-item eu-basis_12 eu-basis_6_sm eu-basis_4_md" v-for="(cycle, index) in cycles" :key="index">
                <div class="el-chunk">
                  <div class="emd-form-box _active _border_base eu-height_100" :class="{ 'eu-border-color_focus': cycle === selectedCycle, '_state_error': !selectedCycle.length && showFeedbacks.status }">
                    <div class="emd-form-box__header">
                      <label class="emd-radio-button" :for="cycle">
                        <input class="emd-radio-button__input" name="cycle" type="radio" :id="cycle" :value="cycle" v-model="selectedCycle">
                        <div class="emd-radio-button__area"></div>
                        <span class="emd-radio-button__text">
                          <span>{{ $t(`cycle.${cycle}.type`) }}</span>
                        </span>
                      </label>
                    </div>
                    <div class="emd-form-box__content">
                      <div class="eu-flex">
                        <div class="eu-flex-item eu-basis_12">
                          <div class="emd-form-group" v-if="cycle === 'predefined'">
                            <label class="emd-label" for="max">{{ $t(`cycle.${cycle}.label`) }}</label>
                            <input class="emd-input" type="text" id="max" name="max" placeholder="0" v-model="item.cycle" @input="filterCycle"
                              :class="{'_state_error': $v.item.cycle.$invalid && showFeedbacks.status && selectedCycle === 'predefined'}"
                              :disabled="selectedCycle !== 'predefined'" />
                            <p class="emd-input-feedback _state_error" v-if="$v.item.cycle.$invalid && showFeedbacks.status && selectedCycle === 'predefined'" >{{ $t('hint.value') }}</p>
                          </div>

                          <div class="emd-form-group" v-else>
                            <p class="emd-input-feedback">{{ $t(`cycle.${cycle}.label`) }}</p>
                          </div>

                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <p class="emd-input-feedback _state_error" v-if="!selectedCycle.length && showFeedbacks.status" >{{ $t('hint.select') }}</p>
          </div>
        </div>
      </div>
      <hr class="emd-divider">
      <div class="emd-container__footer eu-py_4_md eu-px_5_md eu-display_block">
        <div class="eu-flex">
          <div class="eu-flex-item eu-basis_12 eu-basis_4_sm eu-basis_3_md">
            <div class="emd-form-group">
              <div class="eu-display_flex">
                <label class="emd-label" for="setup">{{ $t('setup.label') }}</label>
                <div class="emd-tip _hoverble">
                  <div class="emd-tip__container">
                    <div class="emd-tip__box _color_contrast _arrow_bottom _position_top">
                      <p class="emd-text _color_nonessential">{{ $t('hint.setup') }}</p>
                    </div>
                  </div>
                  <span class="eu-ml_1">
                    <i class="uil uil-info-circle"></i>
                  </span>
                </div>
              </div>
              <money class="emd-input" id="setup" name="setup" v-bind="money" v-model="subscription.setup.amount" @input="filterSetup" :class="{'_state_error': setupValidatorDescription && showFeedbacks.status}"></money>
              <p class="emd-input-feedback _state_error" v-if="setupValidatorDescription && showFeedbacks.status" >{{ $t('hint.value') }}</p>
            </div>
          </div>
          <div class="eu-flex-item eu-basis_12 eu-basis_8_sm eu-basis_5_md">
            <div class="emd-form-group">
              <label class="emd-label" for="setup_description">{{ $t('setup.description') }}</label>
              <input class="emd-input" type="text" name="setup_description" id="setup_description" v-model="subscription.setup.description" :class="{'_state_error': setupValidatorAmount && showFeedbacks.status}" />
              <p class="emd-input-feedback _state_error" v-if="setupValidatorAmount && showFeedbacks.status" >{{ $t('hint.required') }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="el-section">
      <div class="eu-display_flex eu-justify_space-between eu-wrap_reverse">
        <button class="emd-btn _color_secondary _type_text _block_mobile" @click="reverseRoute">
          <i class="uil uil-angle-left"></i>
          {{ $t('back') }}
        </button>
        <button class="emd-btn _color_secondary _block_mobile eu-mb_5_mobile" @click="nextRoute">
          {{ $t('customer') }}
          <i class="uil uil-angle-right"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { Money } from 'v-money'
import { required } from 'vuelidate/lib/validators'
import EmdAlert from '@/components/emerald/molecules/EmdAlert'
import { validateDateFormat, fromatParseDate, setCurrentDate, filterChar } from '@/utils/validations'

export default {
  name: 'SubscriptionDetails',
  components: {
    Money,
    EmdAlert
  },
  beforeMount () {
    if (this.item.cycle === 0) this.selectedCycle = 'not_defined'
    if (this.item.cycle > 0) this.selectedCycle = 'predefined'
  },
  computed: {
    item () {
      return this.$store.getters.itemSubscription[0]
    },
    subscription () {
      return this.$store.getters.subscription
    },
    cycles () {
      return this.$store.getters.cycles
    },
    interval () {
      return this.$store.getters.interval
    },
    today () {
      return setCurrentDate(0)
    },
    routesWizard () {
      return this.$store.getters.routesWizard
    },
    formIsValid () {
      return this.$v.$invalid || this.validateStartAt || this.setupValidator
    },
    selectedPaymentType () {
      return this.$store.getters.selectedPaymentType
    },
    tabbarError () {
      return this.$store.getters.tabbarError
    },
    showFeedbacks () {
      return this.$store.getters.showFeedbacks
    },
    validateStartAt () {
      if (this.subscription.start_at.length === 10 && validateDateFormat(this.subscription.start_at)) {
        const today = fromatParseDate(this.today)
        const startAt = fromatParseDate(this.subscription.start_at)
        return today > startAt
      } return true
    },
    totalAmount () {
      return this.$store.getters.total
    },
    setupValidator () {
      if (this.setupValidatorDescription || this.setupValidatorAmount) return this.setupValidatorDescription || this.setupValidatorAmount
      return false
    },
    setupValidatorDescription () {
      return this.subscription.setup.description.length && this.subscription.setup.amount === 'R$ 0,00'
    },
    setupValidatorAmount () {
      return this.subscription.setup.amount !== 'R$ 0,00' && !this.subscription.setup.description.length
    }
  },
  data () {
    return {
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: true
      },
      selectedCycle: ''
    }
  },
  validations: {
    item: {
      description: { required },
      price: {
        required,
        isNotZero (value) {
          if (value !== 'R$ 0,00') return true
          return false
        }
      },
      quantity: { required },
      cycle: { required }
    },
    subscription: {
      interval: { required },
      interval_count: { required }
    }
  },
  methods: {
    reverseRoute () {
      this.$router.push({ name: 'OrderType' })
    },
    filterCharQuantity (value) {
      if (value === '0' || value === null) return ''
      return value.replace(/[^\d]+/g, '')
    },
    filterInterval () {
      this.subscription.interval_count = this.filterCharQuantity(this.subscription.interval_count)
    },
    filterCycle () {
      this.item.cycle = this.filterCharQuantity(this.item.cycle)
    },
    filterPrice () {
      this.item.price = filterChar(this.item.price)
    },
    filterSetup () {
      this.subscription.setup.amount = filterChar(this.subscription.setup.amount)
    },
    nextRoute () {
      if (this.formIsValid) this.showFeedbacks.status = true
      else this.$router.push({ name: 'Customer' })
    }
  },
  watch: {
    formIsValid: {
      handler: function () {
        this.$store.dispatch('SET_PERMISSION', {
          status: this.formIsValid,
          component: this.$route.name,
          paymentType: this.selectedPaymentType
        })
        this.tabbarError.status = false
        this.showFeedbacks.status = false
      }
    },
    selectedCycle: {
      handler: function () {
        if (this.selectedCycle === 'not_defined') this.item.cycle = 0
        else if (this.item.cycle === 0 && this.selectedCycle === 'predefined') this.item.cycle = null
      }
    }
  }
}
</script>

<i18n>
{
  "pt-BR": {
    "title": "Como será feita a cobrança?",
    "amount": "Valor",
    "description": "Descrição",
    "interval_count": "Cobrar a cada",
    "today": "Hoje - {today}",
    "interval": {
      "day": "Dia(s)",
      "week": "Semana(s)",
      "month": "Mês(es)",
      "year": "Ano(s)"
    },
    "start_at": "Primeira cobrança em",
    "cycle": {
      "title": "Qual será o ciclo da sua assinatura?",
      "predefined": {
        "type": "Pré-definido",
        "label": "Máximo de cobranças"
      },
      "not_defined": {
        "type": "Indefinido",
        "label": "A cobrança será feita periodicamente como for configurada até que ocorra uma pausa manual na assinatura."
      }
    },
    "setup": {
      "label": "Custo de adesão",
      "description": "Descrição"
    },
    "hint": {
      "amount": "Cobrado por periodo",
      "setup": "Cobrança opcional relacionada à matrícula/adesão ao serviço. Será cobrada uma única vez no início da assinatura.",
      "required": "Este campo é obrigatório",
      "date": "A data não pode ser inferior a data de hoje ({date})",
      "select": "Selecione uma opção",
      "value": "Deve ser maior que 0"
    },
    "back": "Voltar ao início",
    "customer": "Dados do cliente",
    "tabbarError": "Alguns campos não foram preenchidos corretamente, por favor verifique."
  },
  "en-US": {
    "title": "How will the subscription be made?",
    "amount": "Value",
    "description": "Description",
    "interval_count": "Charge each",
    "today": "Today - {today}",
    "interval": {
      "day": "Day(s)",
      "week": "Week(s)",
      "month": "Month(s)",
      "year": "Year(s)"
    },
    "start_at": "First charge at",
    "cycle": {
      "title": "What will the cycle of the subscription be?",
      "predefined": {
        "type": "Predefined",
        "label": "Max charges"
      },
      "not_defined": {
        "type": "Undefined",
        "label": "The charge will be made periodically as setup until the subscription is manually paused."
      }
    },
    "setup": {
      "label": "Setup cost",
      "description": "Description"
    },
    "hint": {
      "amount": "Charged within an interval",
      "setup": "Optional charge related to the registration of the service. Will be charged only once when subscription begins.",
      "required": "This field is required",
      "date": "The date cannot be less than today's date ({date})",
      "select": "Select an option",
      "value": "Must be greather than 0"
    },
    "back": "Back to start",
    "customer": "Customer",
    "tabbarError": "Some fields were filled incorrectly, please verify"
  }
}
</i18n>
